import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getSelectedOrders } from '~/selectors/orders.selectors';
import { trackingHelper } from '.';
import { useBlackbeardOrdersVisibility } from '~/pages/BlackbeardOrdersOptInOptOut/useBlackbeardOrdersVisibility';
import { useTrackedOrderDetailsAndUserData } from './trackedOrderDetails';

export function useTrackingHelper() {
  const { showOrdersRedesign } = useBlackbeardOrdersVisibility();
  trackingHelper.appVersion = showOrdersRedesign ? 'blackbeard' : 'classic';

  const selectedOrders = useSelector(getSelectedOrders);
  // get the orderId from the route
  const { pathname } = useLocation();

  // TODO: We're currently talking about ORDERS. Where do batch entries factor into this?
  // For example, I could have one order split three times. Same Order ID. Do we want to track these independently?
  // Not all orders have batch entry IDs. We can't rely on Batch Entry.
  useEffect(() => {
    trackingHelper.selectedOrders = selectedOrders;
    const ordersSelected = Object.keys(selectedOrders).length;
    trackingHelper.isBulk = ordersSelected > 1;

    switch (ordersSelected) {
      case 0: {
        trackingHelper.orderId = undefined;
        trackingHelper.orderIds = undefined;
        trackingHelper.isBulk = false;
        break;
      }
      case 1: {
        trackingHelper.orderId = Object.keys(selectedOrders)[0];
        trackingHelper.orderIds = undefined;
        trackingHelper.isBulk = false;
        break;
      }
      default: {
        trackingHelper.orderId = undefined;
        trackingHelper.orderIds = Object.keys(selectedOrders);
        trackingHelper.isBulk = true;
      }
    }
  }, [selectedOrders]);

  const { trackedOrderDetailsByShipment, userDetails } =
    useTrackedOrderDetailsAndUserData(selectedOrders);
  useEffect(() => {
    trackingHelper.trackedOrderDetailsByShipment = trackedOrderDetailsByShipment;
    trackingHelper.userDetails = userDetails;
  }, [trackedOrderDetailsByShipment, userDetails]);

  const hasOrderIdInRouteRef = useRef(false);

  useEffect(() => {
    let orderId: string | undefined = undefined;
    if (pathname.startsWith('/orders/')) {
      const split = pathname.split('/');
      const detectedId = split[2];
      if (
        detectedId?.match(
          /^[0-9A-F]{8}-?[0-9A-F]{4}-?[4][0-9A-F]{3}-?[89AB][0-9A-F]{3}-?[0-9A-F]{12}$/i,
        )
      ) {
        orderId = detectedId;
      }
    }

    if (orderId) {
      hasOrderIdInRouteRef.current = true;
      trackingHelper.orderId = orderId;
      trackingHelper.orderIds = undefined;
      trackingHelper.isBulk = false;
    } else {
      // Only unset the tracked orderId when we browse away from an order page
      if (hasOrderIdInRouteRef.current) {
        hasOrderIdInRouteRef.current = false;
        trackingHelper.orderId = undefined;
        trackingHelper.orderIds = undefined;
        trackingHelper.isBulk = false;
      }
    }
  }, [pathname]);
}
